import React from "react";
import "./App.css";
import { GoToVideo } from "./GoToVideo";

function App() {
  return <GoToVideo />;
}

export default App;
